// extracted by mini-css-extract-plugin
export default {"popover":"PopoverSharedStyle_popover__5FvL-","active":"PopoverSharedStyle_active__37MQ7","backdrop":"PopoverSharedStyle_backdrop__2vbBV"};